import { Divider, Stack } from '@moda/om';
import React, { useMemo, useState } from 'react';
import { useDesktopNavigationV2 } from '../useDesktopNavigationV2';
import { DesktopNavigationV2MainContentCategory } from '../DesktopNavigationV2MainContentCategory';
import { DesktopNavigationV2Pulldown } from '../DesktopNavigationV2Pulldown';
import { DesktopSiteNavItemLoading } from '../../SiteNav/DesktopSiteNav/DesktopSiteNavItemLoading';

import './DesktopNavigationV2MainContent.scss';

export const DesktopNavigationV2MainContent = () => {
  const { selectedVerticalData } = useDesktopNavigationV2();

  const [activeCategory, setActiveCategory] = useState<undefined | string>(undefined);

  const pulldownContent = useMemo(() => {
    if (!selectedVerticalData) return;

    if (!activeCategory) return;

    return selectedVerticalData.items.find(item => item.id === activeCategory);
  }, [activeCategory, selectedVerticalData]);

  return (
    <div
      className="DesktopNavigationV2MainContent"
      data-testid="DesktopNavigationV2MainContent"
      onMouseLeave={() => setActiveCategory(undefined)}
    >
      <Stack space={3}>
        <Divider color="klein-blue" />
        {!selectedVerticalData && <DesktopSiteNavItemLoading />}

        {selectedVerticalData && (
          <Stack direction="horizontal" justifyContent="center" space={5}>
            {selectedVerticalData.items.map(item => (
              <DesktopNavigationV2MainContentCategory
                key={item.id}
                category={item}
                selected={activeCategory === item.id}
                onSelect={() => setActiveCategory(item.id)}
              />
            ))}
          </Stack>
        )}
      </Stack>

      {pulldownContent && <DesktopNavigationV2Pulldown content={pulldownContent} />}
    </div>
  );
};
